import type { Dispatch, SetStateAction } from 'react'

import CrownIcon from '@/assets/icons/icon-crown.svg'
import TelegramIcon from '@/assets/icons/icon-telegram.svg'
import WhatsAppIcon from '@/assets/icons/icon-whatsapp.svg'
import { Button } from '@/components/ui/button.tsx'

import { vipSupportLinks } from '../data/vip-support-links.ts'
import { VipSupportServices } from '../types'

interface VipSupportCardProps {
  setCurrentService: Dispatch<SetStateAction<VipSupportServices>>
}

export const VipSupportCard = ({ setCurrentService }: VipSupportCardProps) => {
  const handleSetCurrentService =
    (service: Exclude<VipSupportServices, 'none'>) => () => {
      if (window.innerWidth <= 425) {
        return window.open(vipSupportLinks[service], '_blank')
      }
      setCurrentService(service)
    }

  return (
    <div className="relative p-[1px] rounded-3xl w-[616px] max-md:w-full max-md:max-w-[616px] shadow-[0_28px_182px_0_rgba(0,0,0,0.04),0_11.698px_76.035px_0_rgba(0,0,0,0.03),_0_6.254px_40.652px_0_rgba(0,0,0,0.02),0_3.506px_22.789px_0_rgba(0,0,0,0.02),0_1.862px_12.103px_0_rgba(0,0,0,0.02),0_0.775px_5.036px_0_rgba(0,0,0,0.01)]">
      <div className="absolute -top-9 left-1/2 -translate-x-1/2 z-10">
        <div className="relative p-[1px] rounded-full">
          <div className="absolute inset-0 rounded-full bg-gradient-from-tr bg-gradient-to-bl from-[rgba(236,196,63,1)] via-[rgba(255,245,215,1)] to-[rgba(236,196,63,1)]" />
          <div className="relative flex items-center justify-center rounded-full bg-card w-16 h-16">
            <CrownIcon />
          </div>
        </div>
      </div>
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-t from-[rgba(241,241,245,1)] dark:from-[rgba(49,54,76,1)] via-[rgba(255,245,215,1)] dark:via-[rgba(255,245,215,1)] dark:to-[rgba(236,196,63,1)] to-[rgba(236,196,63,1)]" />
      <div className="relative flex flex-col items-center justify-center rounded-3xl bg-card pt-12 pb-7 border-">
        <div className="flex flex-col items-center justify-center gap-3">
          <h2 className="text-center text-3xl font-semibold text-title max-md:w-5/6">
            Join the VIP Experience
          </h2>
          <div className="w-[520px] text-center text-base font-normal text-text-sub max-md:w-5/6 max-md:max-w-[460px]">
            Get 24/7 priority support with your personal assistant, tailored to
            elevate your CreatorHero journey!
          </div>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="w-[520px] text-center text-base font-normal text-secondary-400 max-md:w-5/6 max-md:max-w-[460px] py-10">
            Whether you&apos;re growing your brand, solving technical issues, or
            strategizing for success, your assistant is always there.
          </div>
          <div className="flex flex-col max-md:gap-3 md:flex-row items-center justify-center gap-4">
            <Button
              onClick={handleSetCurrentService(VipSupportServices.whatsapp)}
              className="flex h-10 w-64 py-4 px-8 items-center justify-center gap-1.5 bg-transparent border-[1px] border-secondary-400 text-sm text-secondary-500 shadow-none hover:bg-[--whatsapp] dark:text-white"
            >
              <WhatsAppIcon className="min-w-4 h-4 w-4 fill-neutral-default group-hover:fill-[--whatsapp] group-hover:text-neutral-default" />
              WhatsApp
            </Button>
            <Button
              onClick={handleSetCurrentService(VipSupportServices.telegram)}
              className="flex h-10 w-64 py-4 px-8 items-center justify-center gap-1.5 bg-transparent border-[1px] border-secondary-400 text-sm text-secondary-500 shadow-none hover:bg-[--telegram] dark:text-white"
            >
              <TelegramIcon className="min-w-4 h-4 w-4 fill-neutral-default group-hover:fill-[--telegram] group-hover:text-neutral-default" />
              Telegram
            </Button>
          </div>
          <span className="text-xs text-center text-secondary-300 pt-4">
            Connect with your assistant now through your favorite platform.
          </span>
        </div>
      </div>
    </div>
  )
}
